import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token: "",
  userId: -1,
  name: "",
  project_id: -1,
  challenges: [],
  allPoints: 0,
  isGametizeUser: false,
  configuration:null,
};

export const gametizeSlice = createSlice({
  name: 'gametizeSlice',
  initialState,
  reducers: {
    gametizeLogin: (state, action) => {
      let data = action.payload;
      return { ...state, ...data }
    },
    gametizeChallenges : (state, action) => {
      state.challenges = action.payload
    },
    gametizeAllPoints : (state, action) => {
      state.allPoints = action.payload
    }, 
    gametizeConfiguration :  (state, action) => {
      state.configuration = action.payload
    },
    gametizeLogout: (state) => {
      state.token = ""
      state.userId = -1
      state.name = ""
      state.project_id = -1
      state.challenges = []
      state.isGametizeUser = false
    },
  },
})

// Action creators are generated for each case reducer function
export const { gametizeLogin, gametizeAllPoints, gametizeChallenges, gametizeConfiguration, gametizeLogout } = gametizeSlice.actions;

export default gametizeSlice.reducer